module.exports = "<div class=\"inlet-wrapp\">\n  <div class=\"inlet-inner\" ng-cloak>\n    <fund-actual></fund-actual>\n  </div>\n</div>\n";